<script setup lang="ts">
import { ButtonMain } from '@caks/uikit/button'
import { IPhoneWrapper } from '@caks/shared/modules/i'
import { useAccountStore } from '@caks/shared/store/store.account'
import { InputField } from '@caks/uikit/input'
import { postPhoneAuth } from '@caks/shared/api/user.route'
import { ref, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const store = useAccountStore()
const emit = defineEmits<{ (emit: 'to-next-step'): void }>()

const time = ref(10)
const isButtonEnabled = ref(false)
const codeNumbers = ref(['', '', '', ''])

const router = useRouter()
const isTg = ref<boolean>(true)
const codeError = ref<boolean>(false)

let intervalTimer: ReturnType<typeof setInterval>

const startTimer = () => {
  isButtonEnabled.value = false
  time.value = 59;

  intervalTimer = setInterval(() => {
    time.value--
  }, 1000)
}

watch(time, (newVal) => {
  if (newVal === 0) {
    clearInterval(intervalTimer)
    isButtonEnabled.value = true
  }
})

onMounted(() => {
  startTimer()
})

const getSmsCode = async () => {
  isTg.value = false;
  startTimer();

  await postPhoneAuth({
    phone: store.phone.replace(/\D/g, ''),
    type: 'flashcall'
  })
}

const goToNext = async (e: Event, index: number) => {
  const value = (e.target as HTMLInputElement).value
  codeError.value = false
  if (value.length && index < codeNumbers.value.length - 1) {
    const nextInput = document.getElementById((index + 1).toString()) as HTMLInputElement
    nextInput.focus()
  } else if (index === codeNumbers.value.length - 1) {
    const currentInput = document.getElementById(index.toString()) as HTMLInputElement
    currentInput.blur()

    const { data, code } = await postPhoneAuth({
      phone: store.phone,
      code: codeNumbers.value.join(''),
    })

    if(code !== 0) {
      codeError.value = true;

      return
    }

    localStorage.setItem('token', data.token)
    emit('to-next-step')
  }
}
</script>

<template>
  <i-phone-wrapper :title="isTg ? 'Код из телеграмм' : 'Теперь введите код'" small-text desktop>
    <template #default>
      <div class="auth__fields">
        <input-field
          v-for="(item, index) in codeNumbers"
          v-model="codeNumbers[index]"
          :key="index"
          :id="index.toString()"
          style="text-align: center; width: 100%"
          maxlength="1"
          placeholder="-"
          type="number"
          @input="(e: Event) => goToNext(e, index)" />
      </div>
      <span v-if="codeError">Код не подходит</span>
    </template>
    <template #subtitle>
      <template v-if="isTg">
        Введите код, который мы выслали на номер <br />{{ store.phone }}
      </template>
      <template v-else>
        На номер {{ store.phone }} поступит звонок.<br />Введите последние 4 цифры номера
      </template>
    </template>
    <template #caption>
      <span v-if="!isButtonEnabled">
        Если код не придет, можно получить новый через {{ time }} сек
      </span>
      <span v-else>Можно получить новый код</span>
    </template>
    <template #button>
      <button-main :disabled="!isButtonEnabled" @click="getSmsCode">
        Не пришел код
      </button-main>
    </template>
  </i-phone-wrapper>
</template>

<style scoped lang="scss">
.auth {
  width: 384px;

  &__user-agreement {
    text-decoration: underline;
  }

  &__form {
    span {
      color: $sub-text;
      @include h5-2;
      margin-top: 10px;
      display: block;
    }
  }

  &__fields {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 16px;
  }
}
</style>
